export enum Cmd {
    PING = 0,                   // 心跳请求
    PONG = 1,                   // 心跳响应
    MESSAGE = 10,          // 消息请求
    MESSAGE_ACK = 11,      // 消息回执
    MESSAGE_BROADCAST = 30,        // 广播消息请求
    MESSAGE_BROADCAST_ACK = 31,    // 广播消息回执
    READ = 101,         // 已读请求
    READ_ACK = 102,         // 已读回执
    RECALL = 103,               // 消息撤回请求
    RECALL_ACK = 104,           // 消息撤回回执
    FORWARD = 105,              // 消息转发
    USER_INFO_CHANGE = 200,          // 用户信息变更通知
    USER_ONLINE = 201,          // 用户上线通知
    USER_OFFLINE = 202,         // 用户下线通知
    USER_TYPING = 203,          // 正在输入通知
    GROUP_CHANGE = 204,          // 群变更通知
    CONNECT_EXECUTE = 301,       //账号连接异常通知
    CUSTOM_SIGNAL = 1001,       // 自定义信令
    ERROR = 10001,              // 错误码
}

export enum Types {
    MSG_TEXT = 1,         // 文本消息
    MSG_IMAGE = 2,        // 图片消息
    MSG_AUDIO = 3,        // 音频消息
    MSG_VIDEO = 4,        // 视频消息
    MSG_FILE = 5,         // 文件消息
    MSG_MERGER = 6,       // 合并消息
    MSG_LOCATION = 7,     // 位置消息
    MSG_CUSTOM = 28,      // 自定义消息
    MSG_TEMPLATE = 29,    // 模板消息
    MSG_TIP = 30,         // 提示消息
}

export enum TemplateTypes {
    JOB_INFO = "JOB_INFO",         // 文本消息
    VITAE_EDIT = "VITAE_EDIT", 
    REAL_AUTH = "REAL_AUTH", 
    BILL_PAY = "BILL_PAY", 
    GUARANTEE_CARD = "GUARANTEE_CARD", 
    DEPOSIT = "DEPOSIT",
    PUSH_JOB = "PUSH_JOB", 
    WX_GROUP = "WX_GROUP", 
    CUSTOM_MODEL = "CUSTOM_MODEL", 
}
export enum ImGroupCmd {
    UPDATE_INFO = "UPDATE_INFO",         // 文本消息
    DISBAND_GROUP = "DISBAND_GROUP", 
    USER_MUTE = "USER_MUTE",
    USER_ROLE_AUTH = "USER_ROLE_AUTH",
    REMOVE_USER = "REMOVE_USER",
}
export interface SendResult {
    status:boolean,
    message:ImMessage,
}

export interface ImMessageData {
    cmd:Cmd,
    message?:ImMessage,
    customData?:ImCustomData
}

export interface ImMessage {
    seq?: string;
    msgId?: string;
    sessionId: number;
    sessionType?: number;
    fromId?: number;
    fromType?: number;
    fromName?: string;
    fromHead?: string;
    groupId?: number;
    toId?: number;
    toType?: number;
    toName?: string;
    toHead?: string;
    content: ImContent;
    msgType: Types;
    status: number;
    createTime?: number;
}

export interface ImContent {
    id?: number;        //id
    code?: string;      //编码
    text?: string;      // 文本消息
    title?: string;     //标题
    content?: string;   //内容
    subTitle?: string;  //子标题或内容
    url?: string;       //地址
    linkText?: string;  //连接文字
    linkType?: string;  //连接类型
    path?: string;      //连接地址 
    fileName?: string;  //文件名
    size?: number;      //大小
    width?: number;     //宽
    height?: number;    //高
    duration?: number;  //时长
    latitude?: number;  //经纬度
    longitude?: number;
    address?: string;   //地址
    tip?: string;       // 提示消息
    min?: number;
    max?: number;
    time?: number;
}

export interface ImCustomData{
    id?: number;
    sessionId?:number;
    seq?:string;
    msgId?: string;
    code?: string;
    status?: boolean;
    text?: string;
    message?: string;
    type?: number;
    count?: number;
    time?: number;
}
